<template>
	<div class="report_container full">
		<el-container class="full">
			<el-aside width="200px" style="background: rgb(244, 244, 245);">
				<div style="padding: 10px;">
					<v-jstree ref="jstree" text-field-name="name" value-field-name="id" :data="emuntree"
						:collapse="false" @item-click="itemClick" v-if="emuntree.length!=0"></v-jstree>
				</div>
			</el-aside>
			<el-container style="position: relative;">
				<goodscommon ref="goodscommon" v-show="knowledgetype == 'goodscommon'" />
				<goodsbase ref="goodsbase" v-show="knowledgetype == 'goodsbase'" />
			</el-container>
		</el-container>
	</div>
</template>
<style scoped>

</style>
<script>
	import VJstree from 'vue-jstree'
	import goodscommon from './goodscommon.vue'
	import goodsbase from './goodsbase.vue'
	export default {
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				knowledgetype:'goodscommon',
				emuntree: [{
					id: 'goodscommon',
					bancktype: '',
					reporttype: '',
					name: '公共知识库',
					opened: true,
					selected: true,
					children: []
				},{
					id: 'goodsbase',
					bancktype: '',
					reporttype: '',
					name: '基础产品知识库',
					opened: true,
					children: []
				}],
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			itemClick(node,item){
				this.knowledgetype = item.id
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			VJstree,
			goodscommon,
			goodsbase
		}
	}
</script>